import React, { useState } from 'react';
import { useAuth } from '../../utils/context/AuthContext';
import { useNavigate, Link } from 'react-router';
const logo = require('../../assets/images/adaptive-icon.png');
const Login = () => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
  });

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const userData = await login({ credentials });
    if (userData && userData.uid) {
      navigate('/profile');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center bg-lightGray h-full w-full gap-12">
      <div>
        <img src={logo} alt="login" className="w-36 h-36" />
        <p className="text-todoister font-boldItalic text-2xl">TODOISTER</p>
      </div>
      <form
        className="w-80 bg-darkGray p-6 rounded-lg shadow-lg justify-center items-center flex flex-col "
        onSubmit={handleSubmit}
      >
        <div className="mb-4 w-full">
          <label htmlFor="email" className="block text-sm font-semiBold text-white">
            Email
          </label>
          <input
            type="email"
            id="email"
            className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-orange focus:border-orange"
            value={credentials.email}
            onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
          />
        </div>
        <div className="mb-4 w-full">
          <label htmlFor="email" className="block text-sm font-semiBold text-white">
            Password
          </label>
          <input
            type="password"
            id="password"
            className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-orange focus:border-orange"
            value={credentials.password}
            onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
          />
        </div>
        <button
          type="submit"
          className=" text-white bg-todoister font-semiBoldItalic w-1/2 py-2 px-4 rounded  hover:bg-todoister-dark"
        >
          Login
        </button>
      </form>
      <div className="text-white font-regular">
        Don't have an account?{' '}
        <Link to="/register" className="text-todoister font-boldItalic text-todoister-dark">
          Register
        </Link>
      </div>
    </div>
  );
};

export default Login;
